import { render } from "./Navbar.vue?vue&type=template&id=298932aa"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=298932aa&lang=css"

import exportComponent from "/Users/romanmatveev/Documents/Dev/html_docs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__